import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { ComponentProps, ReactNode, forwardRef, memo } from 'react'
import styled from 'styled-components'
import _DropdownFooter from '../_DropdownFooter'
import shallowEqualWithNestedProps from 'lib/memoize/shallowEqualWithNestedProps'

const Container = styled(_DropdownFooter)`
  padding: ${rem(16)} ${rem(24)} ${rem(24)};
`

const StartSlot = styled.div`
  flex-grow: 1;

  &:empty {
    display: none;
  }
`

interface PrimaryActionProps extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'variant'> {}
interface SecondaryActionProps extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'variant'> {
  kind: 'secondary' | 'tertiary'
}

interface Props {
  primaryActionProps?: PrimaryActionProps
  isPrimaryActionHidden?: boolean
  secondaryActionProps?: SecondaryActionProps
  isSecondaryActionHidden?: boolean
  startSlot?: ReactNode
  actionsSlot?: ReactNode
}

const DropdownSheetFooter = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    primaryActionProps,
    isPrimaryActionHidden,
    secondaryActionProps,
    isSecondaryActionHidden,
    startSlot,
    actionsSlot,
  } = props

  const hasPrimaryAction = !isPrimaryActionHidden && !!primaryActionProps?.children
  const hasSecondaryAction = !isSecondaryActionHidden && !!secondaryActionProps?.children

  return <Container ref={ref}>
    <Group direction="horizontal" horizontalAlign="end" verticalAlign="center" gap={16} wrap="wrap">
      {!!startSlot && <StartSlot>{startSlot}</StartSlot>}
      <Group
        direction="horizontal"
        horizontalAlign="end"
        verticalAlign="end"
        gap={8}
        wrap="wrap"
        noDisplayWhenEmpty
      >
        {hasSecondaryAction && <TextButton
          size="medium"
          {...secondaryActionProps}
          variant="default"
        />}
        {hasPrimaryAction && <TextButton
          size="medium"
          {...primaryActionProps}
          kind="primary"
          variant="default"
        />}
        {actionsSlot}
      </Group>
    </Group>
  </Container>
})

export default memo(DropdownSheetFooter, shallowEqualWithNestedProps(['primaryActionProps', 'secondaryActionProps']))
